'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.addGraphQLSubscriptions = addGraphQLSubscriptions;
exports.default = install;

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _printer = require('graphql-tag/printer');

var _smartApollo = require('./smart-apollo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vue = void 0;
var apolloClient = null;

var keywords = ['subscribe', '$subscribe', '$skipAll', '$skipAllQueries', '$skipAllSubscriptions'];

var defineReactive = function defineReactive() {};

// quick way to add the subscribe and unsubscribe functions to the network interface
function addGraphQLSubscriptions(networkInterface, wsClient) {
  return Object.assign(networkInterface, {
    subscribe: function subscribe(request, handler) {
      return wsClient.subscribe({
        query: (0, _printer.print)(request.query),
        variables: request.variables
      }, handler);
    },
    unsubscribe: function unsubscribe(id) {
      wsClient.unsubscribe(id);
    }
  });
}

var DollarApollo = function () {
  function DollarApollo(vm) {
    _classCallCheck(this, DollarApollo);

    this._apolloSubscriptions = [];
    this._watchers = [];

    this.vm = vm;
    this.queries = {};
    this.subscriptions = {};
  }

  _createClass(DollarApollo, [{
    key: 'watchQuery',
    value: function watchQuery(options) {
      var _this = this;

      var observable = this.client.watchQuery(options);
      var _subscribe = observable.subscribe.bind(observable);
      observable.subscribe = function (options) {
        var sub = _subscribe(options);
        _this._apolloSubscriptions.push(sub);
        return sub;
      };
      return observable;
    }
  }, {
    key: 'subscribe',
    value: function subscribe(options) {
      var _this2 = this;

      var observable = this.client.subscribe(options);
      var _subscribe = observable.subscribe.bind(observable);
      observable.subscribe = function (options) {
        var sub = _subscribe(options);
        _this2._apolloSubscriptions.push(sub);
        return sub;
      };
      return observable;
    }
  }, {
    key: 'option',
    value: function option(key, options) {
      this.queries[key] = new _smartApollo.SmartQuery(this.vm, key, options);
    }
  }, {
    key: 'subscribeOption',
    value: function subscribeOption(key, options) {
      this.subscriptions[key] = new _smartApollo.SmartSubscription(this.vm, key, options);
    }
  }, {
    key: 'defineReactiveSetter',
    value: function defineReactiveSetter(key, func) {
      var _this3 = this;

      this._watchers.push(this.vm.$watch(func, function (value) {
        _this3[key] = value;
      }, {
        immediate: true
      }));
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._watchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var unwatch = _step.value;

          unwatch();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var key in this.queries) {
        this.queries[key].destroy();
      }
      for (var _key in this.subscriptions) {
        this.subscriptions[_key].destroy();
      }
      this._apolloSubscriptions.forEach(function (sub) {
        sub.unsubscribe();
      });
      this._apolloSubscriptions = null;
      this.vm = null;
    }
  }, {
    key: 'client',
    get: function get() {
      return apolloClient;
    }
  }, {
    key: 'query',
    get: function get() {
      return this.client.query;
    }
  }, {
    key: 'mutate',
    get: function get() {
      return this.client.mutate;
    }
  }, {
    key: 'skipAllQueries',
    set: function set(value) {
      for (var key in this.queries) {
        this.queries[key].skip = value;
      }
    }
  }, {
    key: 'skipAllSubscriptions',
    set: function set(value) {
      for (var key in this.subscriptions) {
        this.subscriptions[key].skip = value;
      }
    }
  }, {
    key: 'skipAll',
    set: function set(value) {
      this.skipAllQueries = value;
      this.skipAllSubscriptions = value;
    }
  }]);

  return DollarApollo;
}();

var prepare = function prepare() {
  var _this4 = this;

  if (this._apolloPrepared) return;
  this._apolloPrepared = true;

  // Lazy creation
  Object.defineProperty(this, '$apollo', {
    get: function get() {
      if (!_this4._apollo) {
        _this4._apollo = new DollarApollo(_this4);
      }
      return _this4._apollo;
    }
  });

  // Prepare properties
  var apollo = this.$options.apollo;
  if (apollo) {
    this._apolloQueries = (0, _lodash2.default)(apollo, keywords);

    // watchQuery
    for (var key in this._apolloQueries) {
      // this.$data[key] = null;
      defineReactive(this, key, null);
    }
  }
};

var launch = function launch() {
  if (this._apolloLaunched) return;
  this._apolloLaunched = true;

  if (this._apolloQueries) {
    // watchQuery
    for (var key in this._apolloQueries) {
      this.$apollo.option(key, this._apolloQueries[key]);
    }
  }

  var apollo = this.$options.apollo;
  if (apollo) {
    if (apollo.subscribe) {
      Vue.util.warn('vue-apollo -> `subscribe` option is deprecated. Use the `$subscribe` option instead.');
      for (var _key2 in apollo.subscribe) {
        this.$apollo.subscribeOption(_key2, apollo.subscribe[_key2]);
      }
    }

    if (apollo.$subscribe) {
      for (var _key3 in apollo.$subscribe) {
        this.$apollo.subscribeOption(_key3, apollo.$subscribe[_key3]);
      }
    }

    defineReactiveSetter(this.$apollo, 'skipAll', apollo.$skipAll);
    defineReactiveSetter(this.$apollo, 'skipAllQueries', apollo.$skipAllQueries);
    defineReactiveSetter(this.$apollo, 'skipAllSubscriptions', apollo.$skipAllSubscriptions);
  }
};

function defineReactiveSetter($apollo, key, value) {
  if (typeof value !== 'undefined') {
    if (typeof value === 'function') {
      $apollo.defineReactiveSetter(key, value);
    } else {
      $apollo[key] = value;
    }
  }
}

function install(pVue, options) {
  if (install.installed) return;
  install.installed = true;

  Vue = pVue;
  defineReactive = Vue.util.defineReactive;
  apolloClient = options.apolloClient;

  var merge = Vue.config.optionMergeStrategies.methods;
  Vue.config.optionMergeStrategies.apollo = function (toVal, fromVal, vm) {
    if (!toVal) return fromVal;
    if (!fromVal) return toVal;

    var toData = Object.assign({}, (0, _lodash2.default)(toVal, keywords), toVal.data);
    var fromData = Object.assign({}, (0, _lodash2.default)(fromVal, keywords), fromVal.data);

    var map = {};
    for (var i = 0; i < keywords.length; i++) {
      var key = keywords[i];
      map[key] = merge(toVal[key], fromVal[key]);
    }

    return Object.assign(map, merge(toData, fromData));
  };

  Vue.mixin({

    // Vue 1.x
    init: prepare,
    // Vue 2.x
    beforeCreate: prepare,

    created: launch,

    destroyed: function destroyed() {
      if (this._apollo) {
        this._apollo.destroy();
        this._apollo = null;
      }
    }

  });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-apollo/lib/vue-plugin.js
// module id = 254
// module chunks = 1